
export enum KitCategories {
  hair_make_up_kit_cat = 1, // associated with a hair_make_up_kit record
  wardrobe_kit_cat = 2, // associated with a wardrobe_kit record
  work_kit_cat = 3, // associated with a work_kit record
  submission_kit_cat = 4, // associated with a submission_kit record
  media_kit_cat = 5, // associated with a submission_kit record
}

export type KitDocumentModel = {
  id: number;
  featured: number;
  created_at: string;
  uuid: string;
  record_type?: string;
  record_id?: number;
  category_id?: number;
  file_url?: string;
  file_name?: string;
  file_content_type?: string;
  cropped_file_url?: string;
  cropped_file_name?: string;
  cropped_file_content_type?: string;
  work_kit_id: number | null; // Assuming IDs are numbers, can be null
  wardrobe_kit_id: number | null;
  hair_make_up_kit_id: number | null;
};

export type SubmissionKitModel = {
  id: number;
  title: string;
  user_id?: number;
  uuid?:string;
  created_at: string;
  kit_documents?: any;
};
export type SubmissionKitFilter = {
  keyword?: string;
};

export interface MediaKitSettingModel {
  imageCount: number;
  videoCount: number;
  imageAllowed: number;
  videoAllowed: number;
};


export type MediaKitModel = {
  id: number;
  user_id?: number;
  uuid?: string;
  created_at: string;
  kit_documents?: KitDocumentModel[];
};

export interface SubmissionKitDocumentModel {
  id: number;
  submission_kit_id: number;
  kit_document_id: number;
  tag: string;
  created_at: string;
  updated_at: string;
  kit_document: KitDocumentModel; // Nested object adhering to KitDocument interface
  not_show?: boolean; // only for UI mgmt
}

export interface HmuKitDocumentModel {
  id: number;
  hair_make_up_kit_id: number;
  kit_document_id: number;
  tag: string;
  created_at: string;
  updated_at: string;
  kit_document: KitDocumentModel; 
  not_show?: boolean;  
}

export interface WardrobeKitDocumentModel {
  id: number;
  wardrobe_kit_id: number;
  kit_document_id: number;
  tag: string;
  created_at: string;
  updated_at: string;
  kit_document: KitDocumentModel
  not_show?: boolean;
}

export interface SbProfilesMediaModel {
  id: number;
  submission_board_id: number;
  user_id: number;
  kit_document_id: number;
  media_status:any;
  tag: string;
  created_at: string;
  updated_at: string;
  kit_document: KitDocumentModel; 

}

export interface SbMediaRequestUserModel {
  first_name: string;
  last_name: string;
}
export interface SbMediaRequestModel {
  id?: number;
  submission_board_id?: number;
  user_id?: number;
  notes: string;
  updated_at: string;
  user: SbMediaRequestUserModel;
}

export interface OverviewKitDocumentModel {
  id: number;
  user_id: number;
  kit_document_id: number;
  tag: string;
  position: number;
  created_at: string;
  updated_at: string;
  kit_document: KitDocumentModel
}